/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lesson_ConfirmationInputs */

const en_lesson_confirmation = /** @type {(inputs: Lesson_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmation`)
};

const he_lesson_confirmation = /** @type {(inputs: Lesson_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אישור`)
};

/**
* | output |
* | --- |
* | "Confirmation" |
*
* @param {Lesson_ConfirmationInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const lesson_confirmation = /** @type {((inputs?: Lesson_ConfirmationInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lesson_ConfirmationInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lesson_confirmation(inputs)
	return he_lesson_confirmation(inputs)
});